import { Jerseys, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";
import { LiteralStringUnion } from "type-fest/source/literal-union";
import { Sx } from "utils/sx";

const useStyles = makeStyles(
    (theme, { jersey }: Pick<MicroBibProps, "jersey">) => {
        const palette =
            jersey && jersey in theme.palette.jerseys
                ? theme.palette.jerseys[jersey as keyof Jerseys]
                : undefined;
        const transparentBorder = jersey && jersey !== "white";
        const borderColor = palette
            ? palette.dark
            : `${theme.palette.border.main} transparent`;

        return {
            bib: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: transparentBorder ? "transparent" : borderColor,
                borderRadius: jersey ? theme.spacing(0.5) : undefined,
                backgroundColor: palette
                    ? palette.priorityBackground
                    : undefined,
                color: palette ? palette.contrast : undefined,
                padding: theme.spacing(0, 0.5),
                minWidth: theme.spacing(1),
                minHeight: theme.spacing(2.5),
            },
        };
    },
);

type MicroBibProps = {
    bib?: string | null;
    jersey?: LiteralStringUnion<keyof Jerseys> | null;
    sx?: Sx;
};

export const MicroBib = ({ bib, jersey, sx }: MicroBibProps) => {
    const classes = useStyles({ jersey });

    if (!bib && !jersey) {
        return null;
    }

    return (
        <Typography variant="label2" className={classes.bib} sx={sx}>
            {bib}
        </Typography>
    );
};
